import React from 'react'
import PropTypes from 'prop-types'
import { UIShowToggle } from 'src/components/house/UIShowToggle'
import BtnHelp from 'src/assets/img/house/btn_help.svg'
import UserProfileCard from 'src/components/house/UserProfileCard'
import EventSlideBanner from 'src/components/myPage/EventSlideBanner'

export const HouseHeader = ({
  user,
  isUIOn,
  onUIToggle,
  onProfileClick,
  onAvatarClick,
  onHelpClick,
  events
}) => {
  return (
    <>
      <div className="absolute flex justify-between top-4 left-4 z-50">
        <div className="flex items-baseline gap-1">
          <UIShowToggle isUIOn={isUIOn} onClick={onUIToggle} />
          {isUIOn && (
            <img
              className="w-6 cursor-pointer hover:scale-105 transition-transform"
              src={BtnHelp}
              alt="rank"
              onClick={onHelpClick}
            />
          )}
        </div>
        <div className="max-w-[70%]">
          {isUIOn && <EventSlideBanner events={events} height={60} />}
        </div>
      </div>
      {isUIOn && (
        <div className="absolute max-w-[80%] bottom-28 right-4 z-50 font-ShinMaruGo tracking-wider">
          <UserProfileCard
            user={user}
            rank={user.ranking}
            onProfileClick={onProfileClick}
            onAvatarClick={onAvatarClick}
          />
        </div>
      )}
    </>
  )
}

HouseHeader.propTypes = {
  user: PropTypes.object,
  isUIOn: PropTypes.bool.isRequired,
  onUIToggle: PropTypes.func.isRequired,
  onProfileClick: PropTypes.func.isRequired,
  onAvatarClick: PropTypes.func,
  onHelpClick: PropTypes.func,
  events: PropTypes.array
}
